<div id="content" class="allcp-form" ng-controller="CustomerProfitAnalyticController" ng-init="init()">
    <div ng-include="'modules/customer/partials/top_menu.html'"></div>
    <header class="navbar navbar-fixed-top subnavbar bg-system">
        <ul class="nav navbar-nav navbar-left">
            <li class="hidden-xs" ng-if="isActive(['customer-accounting'])">
                <a class="navbar-fullscreen toggle-active" href="/customer-accounting">
                    <strong class="p10 fs18">Accounting</strong>
                </a>
            </li>
        </ul>
    </header>
    <div class="row mt20">
        <div class="col-md-12 mb20">
            <div class="panel date-range">
                <div class="panel-body" >
                    
                    <div class="row mt50">
                        <div class="col-lg-3">
                            <div class="small-box bg-blue">
                                <div class="icon small-box-icon-blue">
                                    <i class="fa fa-file-text-o"></i>
                                </div>
                                <div class="inner">
                                    <p>Toplam Kargo</p>
                                    <div class="inner">
                                        <h3><i class="fa fa-pie-chart"></i> {{ data.count.total?data.count.total:0 }} </h3>
                                        <!-- <hr style="margin: 10px;border-top: 1px solid #54aed3;">
                                        <h5><i class="fa fa-money"></i> {{ data.total_credit?data.total_credit:0 }} ₺</h5> -->
                                    </div>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="small-box bg-green">
                                <div class="icon small-box-icon-green">
                                    <i class="fa fa-check-square-o"></i>
                                </div>
                                <div class="inner">
                                    <p>Tamamlanan Kargo</p>
                                    <h3><i class="fa fa-pie-chart"></i> {{ data.count.success?data.count.success:0 }} </h3>
                                    <!-- <hr style="margin: 10px;border-top: 1px solid #74bc66;">
                                    <h3><i class="fa fa-money"></i> {{ data.success_credit?data.success_credit:0 }} ₺</h3> -->
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="small-box bg-yellow">
                                <div class="icon small-box-icon-yellow">
                                    <i class="fa fa-sun-o"></i>
                                </div>
                                <div class="inner">
                                    <p>Devam Eden Kargo</p>
                                    <h3><i class="fa fa-pie-chart"></i> {{ data.count.total - (data.count.success + data.count.fail) }} </h3>
                                    <!-- <hr style="margin: 10px;border-top: 1px solid #d7b40d;">
                                    <h3><i class="fa fa-money"></i> {{ Number(data.total_credit) - Number(data.success_credit) + Number(data.fail_credit) }} ₺</h3> -->
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="small-box bg-red">
                                <div class="icon small-box-icon-red">
                                    <i class="fa fa-times"></i>
                                </div>
                                <div class="inner">
                                    <p>İade Olan Kargo / Tutar</p>
                                    <h3><i class="fa fa-pie-chart"></i> 
                                        {{ data.count.fail?data.count.fail:0 }}
                                    </h3>
                                    <!-- <hr style="margin: 10px;border-top: 1px solid #bc3f2a;">
                                    <h3><i class="fa fa-money"></i> {{ data.fail_credit?data.fail_credit:0 }} ₺</h3> -->
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="row mt50">
                        <div class="col-lg-2-4">
                            <div class="small-box bg-blue">
                                <div class="icon small-box-icon-blue">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>Toplam Taşınan Tutar</p>
                                    <h3><i class="fa fa-pie-chart"></i> {{ data.total_credit | number : 2  }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-2-4" ng-repeat="item in data.money_by_type">
                            <div class="small-box bg-green">
                                <div class="icon small-box-icon-green">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>{{ item.name }} Kapıda Alınan Tutar</p>
                                    <h3><i class="fa fa-money"></i>{{ item.sum }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="row mt50">
                        <div class="col-lg-2">
                            <div class="small-box bg-blue">
                                <div class="icon small-box-icon-blue">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>Toplam Borç Tutarı </p>
                                    <h3><i class="fa fa-pie-chart"></i> {{ totalMoney | number : 2  }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-2" ng-repeat="item in data.money_by_customer">
                            <div class="small-box bg-green">
                                <div class="icon small-box-icon-green">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>{{ item.name }} Borç Tutarı</p>
                                    <h3><i class="fa fa-pie-chart"></i>{{ item.sum }} ₺ </h3>
                                    <hr style="margin: 10px;border-top: 1px solid #74bc66;">
                                    <h5><i class="fa fa-money"></i> {{ item.sum_order }} Adet</h5>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <hr>

                    <div class="row mt50">
                        <div class="col-lg-6">
                            <div class="small-box bg-green">
                                <div class="icon small-box-icon-green">
                                    <i class="fa fa-check-square-o"></i>
                                </div>
                                <div class="inner">
                                    <p>Firmaya Verilen Toplam Tutar</p>
                                    <h3><i class="fa fa-pie-chart"></i> {{ data.payment_by_customer.alinan }} ₺ </h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="small-box bg-blue">
                                <div class="icon small-box-icon-blue">
                                    <i class="fa fa-file-text-o"></i>
                                </div>
                                <div class="inner">
                                    <p>Firmadan Alınan Toplam Tutar</p>
                                    <div class="inner">
                                        <h3><i class="fa fa-pie-chart"></i> {{ data.payment_by_customer.verilen }} ₺ </h3>
                                    </div>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <hr>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="table-responsive" ng-if="data.payments.length > 0">
                                <table class="table table-hover tc-checkbox-1 table-scroll fs13">
                                    <thead>
                                        <tr class="bg-light">
                                            <th>
                                                ID
                                                <a ng-click="sort('id','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                                    <i class="fa fa-sort-alpha-desc"></i>
                                                </a>
                                                <a ng-click="sort('id','asc')" ng-if="filterData.sort == 'desc'">
                                                    <i class="fa fa-sort-alpha-asc"></i>
                                                </a>
                                            </th>
                                            <th>Açıklama</th>
                                            <th>Tutar</th>
                                            <th>Ödeme Türü</th>
                                            <th>
                                                Tarihi
                                                <a ng-click="sort('created_at','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                                    <i class="fa fa-sort-alpha-desc"></i>
                                                </a>
                                                <a ng-click="sort('created_at','asc')" ng-if="filterData.sort == 'desc'">
                                                    <i class="fa fa-sort-alpha-asc"></i>
                                                </a>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <tr 
                                        dir-paginate="item in data.payments | itemsPerPage: 30" 
                                        total-items="data.payments.total" 
                                        current-page="data.payments.current_page"
                                        ng-class="{ 'success' : item.status.id == data.successID  }">
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">#{{item.id}}</td>
                                        <td class="clickable-row mw200" ng-click="getOrderDetails(item)">{{ item.description }}</td>
                                        <td class="clickable-row mw200" ng-click="getOrderDetails(item)">{{ item.price }}</td>
                                        <td class="clickable-row mw200" ng-click="getOrderDetails(item)">
                                            <span class="badge badge-success" ng-if="item.type == 0">Alınan Tutar</span>
                                            <span class="badge badge-warning" ng-if="item.type == 1">Verilen Tutar</span>
                                        </td>
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.created_at | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                                <dir-pagination-controls 
                                    boundary-links="true" 
                                    on-page-change="getPage(newPageNumber)" 
                                    template-url="dirPagination.tpl.html"
                                    class="pagination-lg pagination">
                                </dir-pagination-controls>
                            </div>
                            <div class="table-responsive" ng-if="data.payments.length == 0">
                                <div class="alert alert-default pastel">
                                    <i class="fa fa-info pr10"></i>
                                    <strong>
                                        Ödeme bulunamadı!
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>